import React, {useMemo} from 'react';
import moment from 'moment';

export default function StatsCard({resources}) {
  const stats = useMemo(() => {
    const list = resources || [];
    const total = list.length;
    const activeList = list.filter(r => r.is_active !== false);
    const active = activeList.length;
    const inactive = total - active;
    const solar = activeList.filter(r => r.use_case === 'solar_power').length;
    const wind = activeList.filter(r => r.use_case === 'wind_power').length;
    const totalBudget = activeList.reduce((sum, r) => {
      const n = parseFloat(r.budget);
      return sum + (Number.isFinite(n) ? n : 0);
    }, 0);
    const lastUpdate = list.reduce((latest, r) => {
      if (!r.updated_at) return latest;
      const t = new Date(r.updated_at).getTime();
      return t > latest ? t : latest;
    }, 0);
    return {total, active, inactive, solar, wind, totalBudget, lastUpdate};
  }, [resources]);

  const budgetLabel = stats.totalBudget > 0
    ? `€${stats.totalBudget.toLocaleString(undefined, {maximumFractionDigits: 0})}`
    : '—';

  return (
    <div className="p-6">
      <h3 className="text-base font-semibold text-gray-900 dark:text-gray-100 mb-4">Stats</h3>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <div className="text-xs text-gray-500 dark:text-gray-400">Total Registered</div>
          <div className="mt-1 text-2xl font-semibold text-gray-900 dark:text-gray-100">{stats.total}</div>
          {stats.total > 0 && (
            <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              <span className="text-green-600 dark:text-green-400 font-medium">{stats.active} active</span>
              {stats.inactive > 0 && <span className="ml-1">· {stats.inactive} inactive</span>}
            </div>
          )}
        </div>

        <div>
          <div className="text-xs text-gray-500 dark:text-gray-400">Active Budget</div>
          <div className="mt-1 text-2xl font-semibold text-gray-900 dark:text-gray-100">{budgetLabel}</div>
          <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">Monthly prize pool</div>
        </div>

        <div>
          <div className="text-xs text-gray-500 dark:text-gray-400">Solar (active)</div>
          <div className="mt-1 text-lg font-semibold text-gray-900 dark:text-gray-100">{stats.solar}</div>
        </div>

        <div>
          <div className="text-xs text-gray-500 dark:text-gray-400">Wind (active)</div>
          <div className="mt-1 text-lg font-semibold text-gray-900 dark:text-gray-100">{stats.wind}</div>
        </div>

        <div className="col-span-2 pt-3 border-t border-gray-100 dark:border-gray-700 flex items-center justify-between">
          <div className="text-xs text-gray-500 dark:text-gray-400">Last Update</div>
          <div className="text-sm text-gray-600 dark:text-gray-300">
            {stats.lastUpdate ? moment(stats.lastUpdate).fromNow() : 'N/A'}
          </div>
        </div>
      </div>
    </div>
  );
}
